export enum DataTypeCode {
  text = 0,
  checkbox = 1,
  number = 2,
  date = 3,
  dropdown = 4,
  warningMessage = 7, // will it remain 7? needs to be confirmed with backend
}
